import script from "./MazdaSm2KeysPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaSm2KeysPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaSm2KeysPanel.vue?vue&type=style&index=0&id=0511293c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0511293c"]])

export default __exports__